import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import styled from 'styled-components';

export const SubscriptionCheckoutWrapper = styled.div`
  ${flex()};
  padding: 0 16px;
  column-gap: 32px;
  max-width: 100%;

  ${media.mobile`
    width: 100%;
    margin: 24px 0;
    flex-direction: column-reverse;
  `}
`;
